<template>
  <v-app id="inspire">
   <header class="headerStyles" id="headerColor">
     <img class="imageLogo" :src="logo" />
     <span class="LogoutStyle" v-if="$sunidhi.logoutBtnDisp">
       <span @click="$sunidhi.LogouttheApplication"><v-btn>LOGOUT</v-btn></span>
     </span>
   </header>

   <v-main class="main-content backgroundStyle">
     <!-- <v-container fluid fill-height fill-width class="pa-0"> -->
       <router-view></router-view>
       <CookieConsent />
     <!-- </v-container> -->
   </v-main>

   <!-- <v-footer color="#003883" style="border-top: 7px solid #FF8200;">
     <v-container fluid py-0 class="FooterStyles">
       &copy; 2023 Access Bank PLC, Botswana. All rights reserved
     </v-container>
   </v-footer> -->
   <v-footer color="#003883" style="border-top: 7px solid #FF8200; bottom: 0; position: fixed; width: 100%; z-index:10000">
     <v-container fluid py-0 class="FooterStyles">
       &copy; 2024 Access Bank PLC, Botswana. All rights reserved
     </v-container>
   </v-footer>
 </v-app>
</template>

<script>
// import LoginPage from './components/LoginPage.vue'
import { db } from '@/sunidhiapp';
import router from './router';
import logoSrc from '@/assets/images/Group49.svg';
import CookieConsent from "@/components/CookieConsent.vue";

export default {
 name: 'App',
 components: {
    CookieConsent,
  },
 data() {
   return {
     drawer: false,
     source: null,
     title: "Sunidhi",
     loggedin: false,
     UserName: '',
     NotificationCount: 0,
     userId: 0,
     logo: logoSrc
   };
 },
 async mounted() {
 
   if (window.top !== window.self) {
      window.top.location = window.self.location; //added for clickjacking
    }
   await this.$sunidhi.checkDBVersion();
   await this.IsLoggedIn();
   this.$sunidhi.logoutBtnDisp = false;
 },
 methods: {
   async IsLoggedIn(path) {
                   var data = await db.User.where("IsLoggedIn").equals(1).toArray();
                   if (data != null && data.length > 0) {
                       localStorage.setItem("UserId", data[0].UserId);
                       this.UserName = data[0].UserName;
                   } else {
                       await db.User.put({ UserId: 1, IsLoggedIn: 1, UserName: 'AccessBank' });
                   }

                   if (window.navigator.onLine) {

                       if (data != null && data.length > 0) {
                           this.loggedin = true;
                           router.push({ name: path });
                       }
                       // else if (this.$route.path == "/") {}
                        else {
                           this.loggedin = false;
                           router.push({ name: "LoginPage" });
                       }
                   } else {
                       if (data != null && data.length > 0) {
                           this.loggedin = true;
                           router.push({ name: path });
                       } 
                       // else if (this.$route.path == "/") {} 
                       else {
                           this.loggedin = false;
                           router.push({ name: "LoginPage" });
                       }
                   }
               },
 }
 
}
</script>

<style>
/* #app {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 -webkit-font-smoothing: antialiased;
 -moz-osx-font-smoothing: grayscale;
 text-align: center;
 color: #2c3e50;
 display: flex;
 flex-direction: column;
 height: 100vh;
} */
</style>

<style scoped>
.backgroundStyle {
background-color: rgba(211, 211, 211, 0.596);
 }
</style>
